<script setup>
import MixedGridFilters from '../mixedGrid/MixedGridFilters.vue';
import { computed, ref } from 'vue';
import { DEFAULT_SORT } from '@phoenix/helpers/mixed-grid-helper';

const props = defineProps({
  uniqueId: {
    type: String,
    required: true,
  },
  filters: {
    type: Array,
    required: true,
  },
  hasFiltersInUrl: {
    type: Boolean,
    default: false,
  },
  productsCount: {
    type: Number,
    default: 0,
  },
  shouldDisplayProductsCount: {
    type: Boolean,
    default: true,
  },
  urlParamPrefix: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['onSortChanged', 'onFiltersChanged', 'filtersInitialized']);

const defaultSort = DEFAULT_SORT;
const sellableFilterId = `sellable--${window.Phoenix.currentCountry}`;
const mixedGridFiltersRef = ref(null);

const shouldDisplayFilters = computed(() => props.filters.length > 0);

const shouldDisplaySellable = computed(
  () => props.filters.find((filter) => filter.id === sellableFilterId) !== undefined,
);

const displayedFilters = computed(() => props.filters.filter((filter) => filter.id !== sellableFilterId));

const toggleFilter = (filterId, value) => {
  mixedGridFiltersRef.value.toggleFilter(filterId, value);
};

defineExpose({ toggleFilter });
</script>

<template>
  <mixed-grid-filters
    v-if="shouldDisplayFilters"
    ref="mixedGridFiltersRef"
    :unique-id="uniqueId"
    :filters="displayedFilters"
    :default-sort="defaultSort"
    :has-filters-in-url="hasFiltersInUrl"
    :products-count="productsCount"
    :should-display-products-count="shouldDisplayProductsCount"
    :should-display-sellable="shouldDisplaySellable"
    :sellable-filter-id="sellableFilterId"
    :url-param-prefix="urlParamPrefix"
    @on-sort-change="emit('onSortChanged', $event)"
    @on-filters-changed="emit('onFiltersChanged', $event)"
    @filters-initialized="emit('filtersInitialized', $event)"
  />
</template>
